var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { ButtonSize } from './button.type';
import React from 'react';
import { cx } from '@emotion/css';
import { cssAlign, cssButtonBase, cssButtonIcon, cssButtonText, cssIsFullWidth, cssSize, } from './css/css';
import { IconSize } from '@axafr-btc-ds/icons';
import { BorderRadius } from '@axafr-btc-ds/layout';
var getButtonComponent = function (href) { return !!href ? 'a' : 'button'; };
var mapIconSize = (_a = {},
    _a[ButtonSize.s] = IconSize.x2,
    _a[ButtonSize.m] = IconSize.x3u,
    _a[ButtonSize.l] = IconSize.x3u,
    _a);
export var AbstractButton = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? 'right' : _c, children = _a.children, className = _a.className, abstractClassName = _a.abstractClassName, Icon = _a.icon, cssTheme = _a.cssTheme, _d = _a.size, size = _d === void 0 ? ButtonSize.l : _d, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, _f = _a.isFullWidth, isFullWidth = _f === void 0 ? false : _f, _g = _a.buttonType, buttonType = _g === void 0 ? 'button' : _g, _h = _a.borderRadius, borderRadius = _h === void 0 ? BorderRadius.u0 : _h, _j = _a.isCircle, isCircle = _j === void 0 ? false : _j, props = __rest(_a, ["align", "children", "className", "abstractClassName", "icon", "cssTheme", "size", "isDisabled", "isFullWidth", "buttonType", "borderRadius", "isCircle"]);
    var ButtonComponent = getButtonComponent(props.href);
    return (React.createElement(ButtonComponent, __assign({}, props, { ref: ref, type: !!props.href ? undefined : buttonType, disabled: isDisabled, className: cx(cssButtonBase(borderRadius, isCircle), cssSize[size], cssAlign[align], (_b = {},
            _b[cssIsFullWidth] = isFullWidth,
            _b), cssTheme, abstractClassName, className) }),
        React.createElement("span", { className: cssButtonText(align === 'center', isCircle) }, children),
        Icon && align !== 'center'
            && React.createElement(Icon, { size: size && isCircle ? '' : mapIconSize[size], className: cx(cssButtonIcon(size, isCircle), 'buttonIcon') })));
});
